module.exports = __webpack_public_path__ + "static/media/8.0a6ed0d6.gif";